export default {
  SET_COIN: "SET_COIN",
  SET_TRANSATION_TYPE: "SET_TRANSATION_TYPE",
  SET_PRODUCTS_COIN: "SET_PRODUCTS_COIN",
  SET_OPERATIONS: "SET_OPERATIONS",
  SET_PUBLIC_STAFF: "SET_PUBLIC_STAFF",
  SET_MANAGE_PUBLIC_RESOURCES: "SET_MANAGE_PUBLIC_RESOURCES",
  SET_POLITICALLY_EXPOSED: "SET_POLITICALLY_EXPOSED",
  SET_POLITICALLY_EXPOSED_RELATIVES: "SET_POLITICALLY_EXPOSED_RELATIVES",
  SET_POLITICALLY_EXPOSED_PERSON: "SET_POLITICALLY_EXPOSED_PERSON",
  SET_CREDIT: "SET_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION",
  SET_RELATIVES: "SET_RELATIVES"
}
